<div class="left-menu-container d-flex flex-column flex-grow-1 h-100">
  <div class="d-flex flex-column m-4">
    <div class="d-flex flex-column">
      <img alt="Logo" class="app-logo" src="assets/images/logo.png"/>
    </div>
  </div>
  <ul class="d-flex flex-column flex-grow-1 list-menu px-0">
    <li *ngFor="let nav of sideNav" class="mx-3 mb-1">
      <a [routerLink]="nav.route"
         class="d-flex align-items-center nav-item"
         routerLinkActive="active" style="border-radius: 8px; gap: 0.75em;">
        <mat-icon [svgIcon]="nav.icon"></mat-icon>
        <span>{{nav.text}}</span>
      </a>
    </li>
  </ul>
  <div class="d-flex flex-grow-1"></div>
  <div class="footer">
    <div class="d-flex flex-row justify-content-left align-items-center mx-4">
      <div class="d-flex flex-column justify-content-center flex-grow-1">
        <span>{{user.fullName}}</span>
      </div>
      <a (click)="onClickLogout()">
        <mat-icon style="width: 1.2rem" svgIcon="exit-ic"></mat-icon>
      </a>
    </div>
  </div>
</div>
